export default __webpack_public_path__ + "static/media/photo--sm--52.73b2172d.jpg";